<template>
  <div>
    <div v-if="showloading" class="text-center">
      <v-progress-circular style="position: absolute; width: 25%; height: 25%; top: 50%; left: 50%; transform: translate(-50%, -50%)" indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
      <LayoutContent>
        <SectionTitle :label="sectionTitle" id="checkout-anchor" />
        <v-stepper alt-labels v-model="currentStep" class="elevation-0">
          <v-stepper-header class="elevation-0 checkout-flow--stepper">
            <template v-for="(step, index) in steps">
              <v-stepper-step :key="`step-${index}`" :complete="currentStep > step" :step="index + 1" style="max-width: 180px">{{ step.title }}</v-stepper-step>
              <v-divider v-if="index < steps.length - 1" :key="`divider-${index}`"></v-divider>
            </template>
          </v-stepper-header>

          <v-stepper-items>
            <!-- step 1 -->
            <v-stepper-content step="1">
              <PaymentMethods v-model="selectedMethod" @payment-method="onPaymentMethodSelected" />
            </v-stepper-content>

            <!-- step 2 -->
            <v-stepper-content step="2">
              <!-- <v-card class="mb-12" color="grey lighten-1" height="200px"></v-card> -->
              <PaymentCard ref="cardForm" v-if="cardPaymentObj" :cardPaymentObj="cardPaymentObj" @payment-succeess="paymentSuccess"></PaymentCard>
              <!-- <v-btn color="primary" @next-step="currentStep++">Continue</v-btn> -->
              <!-- <v-btn text>Cancel</v-btn> -->
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </LayoutContent>
      <bottom-bar v-show="bottom">
        <v-container class="py-3 d-flex align-center">
          <span
            class="white--text font-weight-bold"
            :class="{
              'mr-10': $vuetify.breakpoint.smAndUp,
              'mr-1': !$vuetify.breakpoint.smAndUp
            }"
          >
            {{ $t('label.totalPayment') }}:
          </span>
          <span class="white--text font-weight-bold mr-auto">{{ orderSummary.currency }} {{ formatAmount(orderSummary.final_amount) }}</span>
          <app-button :label="nextStepName" @click="nextStep" v-if="!hideButton" />
        </v-container>
      </bottom-bar>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import LayoutContent from '@/views/layouts/LayoutContent'
import SectionTitle from '@/components/SectionTitle.vue'
import PaymentMethods from '@/components/checkout/PaymentMethods.vue'
import PaymentCard from '@/components/checkout/PaymentCard.vue'
import { localeHelper, uiHelper } from '@/utils'
import { PAYMENT } from '@/api/payment.api'
import Config from '@/config.json'

export default {
  props: { poNumber: { required: true } },
  components: {
    LayoutContent,
    SectionTitle,
    PaymentMethods,
    PaymentCard
  },
  data() {
    return {
      showloading: false,
      stripe: Stripe(Config.VUE_APP_STRIPE),
      currentStep: 1,
      steps: [{ title: localeHelper.getMessage('label.selectPaymentMethod') }, { title: localeHelper.getMessage('label.makePayment') }, { title: localeHelper.getMessage('label.pay') }],
      popup: null,
      paymentComplete: false,
      abortController: new AbortController(),
      selectedMethod: '',
      orderSummary: null,
      cardPaymentObj: []
    }
  },
  mounted() {
    this.fetchDetail()
    window.addEventListener('message', this.handlePaymentMessage, { signal: this.abortController.signal }, true)
  },
  computed: {
    sectionTitle() {
      let title = this.steps[this.currentStep - 1].title
      return title
    },
    nextStepName() {
      let label = ''
      if (this.currentStep < this.steps.length) {
        label = this.steps[this.currentStep].title
      }
      return label
    },
    bottom() {
      return true
    },
    hideButton() {
      if (this.currentStep == 1) {
        if (this.selectedMethod === '') return true
      }
      return false
    }
  },
  watch: {
    currentStep() {
      this.$el.querySelector('#checkout-anchor').scrollIntoView()
    }
  },
  methods: {
    ...mapActions('order', ['getOrderDetail']),
    async fetchDetail() {
      await this.getOrderDetail(this.poNumber).then((res) => {
        this.orderSummary = res.order
      })
    },
    async nextStep() {
      if (this.orderSummary.final_amount < 1.5 && this.selectedMethod.paymentMethod === 'atome') this.$toast.error(this.$t('error.paymentMethodUnsupported'))
      else {
        if (this.selectedMethod.value === 'atome') {
          this.popup = window.open()
          await PAYMENT.makePayment(this.poNumber, this.selectedMethod.paymentMethod).then((paymentRes) => {
            let url = null
            if (this.selectedMethod.value === 'atome') {
              url = paymentRes.redirect_url
            } else {
              url = URL.createObjectURL(new Blob([paymentRes], { type: 'text/html' }))
            }
            this.popup.location = url
            var popupTick = setInterval(() => {
              if (this.popup.closed) {
                clearInterval(popupTick)
                this.abortController.abort()
                if (!this.paymentComplete) this.$router.push({ name: this.$constants.ROUTE_NAME.ORDER_LIST, params: { id: 1 } })
              }
            }, 500)
          })
        } else if ((this.selectedMethod.value === 'stripe' || this.selectedMethod.value === 'stripeGrab') && this.currentStep !== 2) {
          await PAYMENT.makeStripePayment([this.poNumber], this.selectedMethod.paymentMethod).then((response) => {
            if (response) {
              this.cardPaymentObj = response
              if (this.cardPaymentObj) {
                if (this.selectedMethod.value === 'stripe') {
                  this.currentStep = 2
                } else {
                  this.processCheckOut()
                }
              }
            }
          })
        } else {
          this.processCheckOut()
        }
      }
    },
    processCheckOut() {
      if (this.selectedMethod.value === 'stripe' && this.currentStep == 2) {
        this.$refs.cardForm.submit()
      } else if (this.selectedMethod.value === 'stripeGrab') {
        var hostname = window.location.origin
        this.showloading = true
        this.stripe.confirmGrabPayPayment(this.cardPaymentObj.client_secret, {
          // Return URL where the customer should be redirected to after the authorization
          return_url: `${hostname}/order`
        })
      }
    },
    formatAmount(amount) {
      return uiHelper.priceFormatter(amount)
    },
    handlePaymentMessage(event) {
      const data = event.data
      if (data.status && this.popup != null) {
        this.paymentComplete = true
        if (data.status == 'success') {
          this.$router.push({ name: this.$constants.ROUTE_NAME.ORDER_PAYMENT_SUCCESS, query: { po_number: this.poNumber } })
        }
        if (data.status == 'fail') {
          this.$router.push({ name: this.$constants.ROUTE_NAME.ORDER_LIST, params: { id: 1 } })
        }
        this.popup.close()
      }
    },
    onPaymentMethodSelected(val) {
      this.selectedMethod = val
    },
    async paymentSuccess() {
      let value = this.cardPaymentObj
      await PAYMENT.paymentSeccess(value).then((response) => {
        if (response) {
          this.$router.push({ name: this.$constants.ROUTE_NAME.ORDER_PAYMENT_SUCCESS, query: { po_number: this.poNumber } })
        }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener('message', this.handlePaymentMessage)
    next()
  }
}
</script>

<style lang="scss" scoped>
.checkout-flow--stepper ::v-deep {
  --stepper-radius: 1.2rem;
  max-width: 900px;
  height: auto;
  margin-left: auto;
  margin-right: auto;

  .v-icon {
    background-color: unset !important;
  }

  .v-divider {
    margin-top: calc(24px + var(--stepper-radius)) !important;
  }

  .v-stepper__step__step {
    width: calc(var(--stepper-radius) * 2);
    height: calc(var(--stepper-radius) * 2);
    font-size: 1.4rem;
    margin-bottom: 0.6rem;
    @include green-gradient(180deg);
  }
  .v-stepper__step--inactive .v-stepper__step__step {
    background: white !important;
    border: 1px solid var(--v-secondary-lighten4);
    color: var(--v-secondary-lighten2);
  }

  .v-stepper__label {
    text-align: center;
    white-space: nowrap;
  }
}
</style>
